import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MatPaginatorIntlExtension extends MatPaginatorIntl {
  constructor(private translateService: TranslateService) {
    super();
    this.setTranslations();

    this.translateService.onLangChange.subscribe(() => {
      this.setTranslations();
      this.changes.next();
    });
  }

  setTranslations() {
    this.itemsPerPageLabel = this.translateService.instant('paginator.items-per-page');
    this.nextPageLabel = this.translateService.instant('paginator.next-page');
    this.previousPageLabel = this.translateService.instant('paginator.previous-page');
    this.firstPageLabel = this.translateService.instant('paginator.first-page');
    this.lastPageLabel = this.translateService.instant('paginator.last-page');
  }

  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    let of = this.translateService.instant('paginator.of');
    if (length === 0 || pageSize === 0) {
      return '0 ' + of + ' ' + length;
    }
    length = Math.max(length, 0);
    const startIndex = ((page * pageSize) > length) ?
      (Math.ceil(length / pageSize) - 1) * pageSize :
      page * pageSize;

    const endIndex = Math.min(startIndex + pageSize, length);
    return startIndex + 1 + ' - ' + endIndex + ' ' + of + ' ' + length;
  };
}